import { keyframes, styled } from 'styled-components'
import colors from '@web-ui-kit/colors'

import { DEVICE_SIZE } from 'utils/constants'

const sonar = keyframes`
  0% {
    transform: scale(1);
    opacity:1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
`

export const NotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 26.9375rem;
  width: 90vw;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    width: 21.5625rem;
  }
`
export const NotificationsHeader = styled.header`
  align-items: center;
  display: flex;
  height: 3.3125rem;
  justify-content: space-between;
  padding: 0 0.7rem;
  text-transform: uppercase;
`

export const NotificationsContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  overflow: auto;
  padding: 0.6875rem 0.6875rem 0;
  & p {
    word-break: break-word;
  }
  & a,
  & button,
  & a > span,
  & span[role='presentation'],
  & span[role='button'] {
    color: ${({ theme }) => theme?.colors?.ACCENT_700};
    font-family: 'Poppins';
    font-size: 0.8125rem;
  }
`

export const Scroller = styled.div`
  display: inherit;
  flex-direction: column;
  gap: 0.6875rem;
  overflow: inherit;
  padding-bottom: 0.6875rem;
  scrollbar-color: ${colors.NEUTRAL_200} transparent;
  scrollbar-width: thin;
  width: 100%;
  ::-webkit-scrollbar {
    width: 0.3125rem;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 0.625rem;
    background-color: ${colors.NEUTRAL_200};
  }
`

export const ButtonIconContainer = styled.div`
  position: relative;
`

export const ButtonIconBadge = styled.div`
  background-color: ${({ theme }) => theme?.colors?.ACCENT_700};
  border-radius: 50%;
  color: ${colors.WHITE};
  display: flex;
  height: 1.1rem;
  justify-content: center;
  top: 0;
  left: 60%;
  bottom: 60%;
  right: 0;
  position: absolute;
  width: 1.1rem;
  &:after {
    content: '';
    animation: ${sonar} 1.2s 1;
    position: absolute;
    border: 0.0625rem solid ${({ theme }) => theme?.colors?.ACCENT_700};
    opacity: 0;
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
`
